var $ = require("jquery");
require("slick-carousel/slick/slick.scss");
require("slick-carousel");

jQuery(function() {
  $(".slider-blocks-variant__list").slick({
    //centerMode: true,
    infinite: true,
    arrows: false,
    dots: true,
    lazyLoad: "ondemand",
    slidesToShow: 4,
    slidesToScroll: 4,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          infinite: false
        }
      }
    ]
  });
});
